module.exports = "/images/man-2.webp?96842d0aa36e3d49161b25413feb4b40";